import { gql } from '@apollo/client';

const CREATE_CREW_MEMBER_HOME_BASE = gql`
	mutation createCrewMemberHomeBase($input: CrewMemberHomeBaseInput!) {
		createCrewMemberHomeBase(input: $input) {
			... on CrewMemberHomeBaseSuccessResponse {
				homeBase {
					id
				}
			}
			... on CrewMemberHomeBaseErrorResponse {
				errors
			}
		}
	}
`;

export default CREATE_CREW_MEMBER_HOME_BASE;
